import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ExpandMore, ExpandLess, DragIndicator } from '@mui/icons-material';
import { Box, Button, IconButton } from '@mui/material';

import { DreConfigConfiguracoesList, DreConfigSubgruposDelete, DreConfigSubgruposEdit } from 'pages/financeiro/dre/configuracao/components';
import { DreConfigConfiguracoesProvider } from 'pages/financeiro/dre/configuracao/contexts/DreConfigConfiguracoesContext';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigSubgruposItem({ subgrupo, isOverlay }: { subgrupo: DreSubgrupo; isOverlay?: boolean }) {
    const { activeSubgrupo, setActiveSubgrupo } = useDreConfigContext();
    const isActiveSubgrupo = !isOverlay && activeSubgrupo?.idDreMercadologicaGrupoExibicao === subgrupo.idDreMercadologicaGrupoExibicao;

    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: subgrupo.idDreMercadologicaGrupoExibicao,
    });

    return (
        <Box
            ref={setNodeRef}
            sx={{
                transition,
                display: 'flex',
                flexDirection: 'column',
                borderWidth: 1,
                borderRadius: 1,
                borderColor: 'grey.300',
                backgroundColor: 'common.white',
                transform: CSS.Transform.toString(transform),
                opacity: isDragging ? 0.6 : 1,
                zIndex: isDragging ? 10 : 'auto',
                borderStyle: isDragging ? 'dashed' : 'solid',
            }}
        >
            <Box
                sx={{
                    gap: 0.5,
                    padding: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottomWidth: isActiveSubgrupo ? 1 : 0,
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'grey.300',
                }}
            >
                <Button
                    variant="text"
                    size="small"
                    sx={{ fontSize: '14px', fontWeight: '700', marginRight: 'auto', textTransform: 'none', lineHeight: '24px' }}
                    startIcon={isActiveSubgrupo ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setActiveSubgrupo(isActiveSubgrupo ? null : subgrupo)}
                >
                    {subgrupo.dsDreMercadologicaGrupoExibicao}
                </Button>

                <DreConfigSubgruposEdit subgrupo={subgrupo} />

                <DreConfigSubgruposDelete subgrupo={subgrupo} />

                <IconButton
                    sx={{ width: 30, height: 30, cursor: 'grab' }}
                    {...listeners} // Aplica os eventos de drag apenas ao botão
                    {...attributes} // Aplica os atributos necessários para o drag
                >
                    <DragIndicator />
                </IconButton>
            </Box>

            {isActiveSubgrupo && (
                <DreConfigConfiguracoesProvider>
                    <DreConfigConfiguracoesList />
                </DreConfigConfiguracoesProvider>
            )}
        </Box>
    );
}
